import { ObjectLiteral } from '@biz2x/libraries/core-utils/interface';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';
import * as AppStateActions from './app-state.actions';
import { AppStateEntity, UTIL_TASKS } from './app-state.models';

export const APP_STATE_FEATURE_KEY = 'appState';

export interface State extends EntityState<AppStateEntity> {
  selectedId?: string | number; // which AppState record has been selected
  session_interceptor?: boolean;
  loaded: boolean; // has the AppState list been loaded
  error?: string | null; // last known error (if any)
  token?: string | null;
  userData?: ObjectLiteral;
  caseData?: ObjectLiteral;
  configurations: any;
  utilResponse: any;
  /** Last util / activity-log dispatch metadata */
  id?: number;
  code?: string;
}

export interface AppStatePartialState {
  readonly [APP_STATE_FEATURE_KEY]: State;
}

export const appStateAdapter: EntityAdapter<AppStateEntity> =
  createEntityAdapter<AppStateEntity>();

export const initialState: State = appStateAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  userData: {},
  configurations: null,
  utilResponse:null
});

const appStateReducer = createReducer(
  initialState,
  on(AppStateActions.init, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(AppStateActions.loadAppStateFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(AppStateActions.loadAppStateSuccess, (state, { appState }) =>
    appStateAdapter.setAll(appState, {
      ...state,
      loaded: true,
    })
  ),
  on(AppStateActions.signOutSuccess, (state) => ({
    ...state,
    token: '',
    userData: {},
  })),
  on(AppStateActions.setUserSession, (state, action) => ({
    ...state,
    token: action.id,
    userData: action.user,
    loaded: true,
  })),
  on(AppStateActions.appConfig, (state, action) => {
    return {
      ...state,
      configurations: action.configurations
    };
  }),
    on(AppStateActions.utilApiTrigger, (state, { id }) => ({
    ...state,
    id,
    code:UTIL_TASKS[id]
  })),
  on(AppStateActions.utilApiSuccess, (state, { id, response }) => ({
    ...state,
    code:UTIL_TASKS[id],
    id,
    utilResponse:response
  })),
  on(AppStateActions.utilApiFailure, (state, { id, error }) => ({
    ...state,
    id,
    code:UTIL_TASKS[id],
    error,
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return appStateReducer(state, action);
}
